import { render } from "./MSInfoItem.vue?vue&type=template&id=30413059"
import script from "./MSInfoItem.vue?vue&type=script&lang=ts"
export * from "./MSInfoItem.vue?vue&type=script&lang=ts"
script.render = render

export default script